import React from 'react'

export default function SectionSkeleton() {
  return (
    <div
      data-testid="section-skeleton"
      className="hc8-bg-base hc8-mv-3x"
      style={{
        minHeight: 240,
        borderRadius: 4,
        animation: 'pulse 1.2s ease-in-out infinite',
      }}
    />
  )
}
